<template>
  <div class="room-bg">
    <div id="id_test_video"></div>
    <div v-if="isTest || isPlay || !liveApplyInfo">
      <div class="room-content">
        <!-- 头部 start -->
        <room-header :showcoupon="showcoupon" :userInfo="userInfo" @attention="attention" :groupInfo="groupInfo" :ifLike="ifLike" :ownerInfo="ownerInfo" @coupon="coupon" @quitGroup="quitGroup"></room-header>
        <!-- 头部 end -->
        <!-- 聊天室 start -->
        <chatroom class="chatroom" :message="messageQueen"></chatroom>
        <!-- 聊天室 end -->
        <!-- 底部 -->
        <room-bottom class="room-bottom" @send-message="sendMessage" :isTimReady="ifConnect" @like="like" @showGift="showGift" @showgoods="showgoods"></room-bottom>
        <!-- 底部 -->
        <!-- 礼物面板 start -->
        <gifts class="gifts" :style="animation?'bottom:0':''" @hideGift="hideGift" @sendgift="sendgift"></gifts>
        <!-- 礼物面板 end -->
        <!-- 商品面板 start -->
        <goods-list class="goodslist" :style="animation2?'bottom:0':''" @hidegoods="hidegoods" @buy="buy" :goods="goods"></goods-list>
        <!-- 商品面板 end -->
        <!-- 礼物以及动画 start -->
        <gift-animation v-if="hasgift" class="gift-animation" :avatar="giftAvatar" :nick="giftNick" @hideani="hideani"></gift-animation>
        <!-- 礼物以及动画 end -->
        <!-- 优惠券 -->
        <coupon class="coupon" v-if="hascoupon" :voucher="voucher" @hidecoupon="hidecoupon" @usecoupon="usecoupon"></coupon>
        <!-- 优惠券 -->
        <!-- 公告start -->
        <!-- <notice class="notice" :noticeText="noticeText" v-if="roomStatus!=='0'"></notice> -->
        <!-- 公告 end -->
      </div>
      <no-owner :ownerInfo="ownerInfo"></no-owner>
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui'
import { mapState, mapActions } from 'vuex'
import roomHeader from './child/header'
import roomBottom from './child/bottom'
import chatroom from './child/chatroom'
import gifts from './child/gifts'
import coupon from './child/coupon'
import notice from './child/notice'
import goodsList from './child/goodslist'
import giftAnimation from './child/gift-animation'
import noOwner from './child/noowner'
import { loadScript,loadCSS } from '../../../util/common'
import { getLiveInfo, joinLive, leaveLive, addGift, addLike } from '../../../api/memberLive'
import { addInstantMessage } from '../../../api/memberInstantMessage'
import { receiveVoucher, getStoreVoucher } from '../../../api/homestoredetail'
import { addFavoriteStore, delFavoriteStore } from '../../../api/memberFavorite'
import { cartAdd } from '../../../api/homecart'
var ws
export default {
  data () {
    return {
      isTest: this.$route.query.test ? 1 : 0,
      live_apply_id: 0,
      message: [],
      userInfo: {},
      groupInfo: {},
      ownerInfo: {},
      ifLike: false,
      animation: false,
      animation2: false,
      hasgift: false,
      giftAvatar: '',
      giftNick: '',
      showcoupon: false,
      hascoupon: false,
      voucherList: false,
      voucher: {},
      voucherIndex: 0,
      goods: [],
      noticeText: '',
      liveApplyInfo: false,
      showChat: true,
      ifConnect: false,
      clientId: false,
      openLive: false,
      closeLive: false,
      isPlay: false,
      lockReconnect: false,
      timeOut: false,
      ifWait: false
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      user: state => state.member.info
    }),
    messageQueen: function () {
      const queenLen = 100 // 内存里面放100条消息，以免观看直播太久撑爆内存
      if (this.message.length > queenLen) {
        const vl = this.message.length - queenLen
        for (let i = 0; i < vl; i++) {
          this.message.shift()
        }
      }
      return this.message
    }
  },
  components: {
    roomHeader,
    roomBottom,
    chatroom,
    gifts,
    coupon,
    notice,
    goodsList,
    giftAnimation,
    noOwner
  },
  created: function () {
    this.fetchConfig({})
    this.live_apply_id = this.$route.query.live_apply_id
    if (!this.live_apply_id) {
      Toast('خطأ في المعلمة')
    }
    const { width, height } = window.screen
    getLiveInfo(this.live_apply_id).then(res => {
      this.liveApplyInfo = res.result.live_apply_info
      getStoreVoucher(this.liveApplyInfo.live_apply_user_id).then(res => {
        this.voucherList = res.result.voucher_list
        if (this.voucherList.length) {
          this.showcoupon = true
        }
      }).catch(error => {
        Toast(error.message)
      })
      if (this.liveApplyInfo.goods_list) {
        this.goods = this.liveApplyInfo.goods_list
      }
      this.groupInfo = {
        groupID: this.liveApplyInfo.live_apply_id,
        memberNum: res.result.online_info.online_count
      }
      this.ifLike = this.liveApplyInfo.is_favorate
      this.ownerInfo = {
        avatar: this.liveApplyInfo.live_apply_user_avatar,
        nick: this.liveApplyInfo.live_apply_user_name,
        fans: this.liveApplyInfo.live_apply_fans
      }
      this.openLive = true
      if (this.liveApplyInfo.instant_message_url) {
        this.createWebSocket()
      }
      var _this = this
      if(this.config.video_type=='aliyun'){
      loadCSS('aliplayer','https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css')
      loadScript('aliplayer', 'https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js', function () {
        var player = new Aliplayer({
          "id": "id_test_video",
          "source": _this.liveApplyInfo.live_apply_play_url,
          "width": width,
          "height": height,
          "autoplay": true,
          "isLive": true,
          "rePlay": false,
          "playsinline": true,
          "preload": true,
          "controlBarVisibility": "hover",
          "useH5Prism": true
        }, function (player) {
            player.play();
            player.on('play',function(){
            _this.isPlay = true
            });
            player.on('pause',function(){
            _this.isPlay = false
            });
            player.on('liveStreamStop',function(){
              MessageBox.confirm('غادر المذيع ، هل تريد مشاهدة البث المباشر الآخر؟').then(action => {
                _this.$router.push({ name: 'MemberLiveList' })
              }).catch(error => {
              })
            });
          }
        );  
      })
      }else{
      loadScript('TcPlayer', '//imgcache.qq.com/open/qcloud/video/vcplayer/TcPlayer-2.3.2.js', function () {
        var player = new TcPlayer('id_test_video', {
          'm3u8_hd': _this.liveApplyInfo.live_apply_play_url, // 请替换成实际可用的播放地址
          // 'autoplay': true, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
          'live': true,
          'controls': 'system',
          'systemFullscreen': true,
          'width': width,
          'height': height,
          'x5_player': true,
          'x5_type': 'h5',
          'x5_fullscreen': 'true',
          'listener': function (res) {
            if (res.type == 'play') {
              _this.isPlay = true
            } else if (res.type == 'pause') {
              _this.isPlay = false
            } else if (res.type == 'error') {
              MessageBox.confirm('غادر المذيع ، هل تريد مشاهدة البث المباشر الآخر؟').then(action => {
                _this.$router.push({ name: 'MemberLiveList' })
              }).catch(error => {
              })
            }
          }
        })
      })
      }
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    hidecoupon () {
      this.hascoupon = false
    },
    usecoupon () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      receiveVoucher(
        this.voucher.vouchertemplate_id
      ).then((res) => {
        this.voucherList.splice(this.voucherIndex, 1)
        if (!this.voucherList.length) {
          this.showcoupon = false
        }
        Toast(res.message)
        this.ifWait = false
      }).catch(function (error) {
        Toast(error.message)
        this.ifWait = false
      })
      this.hidecoupon()
    },
    coupon () {
      this.voucherIndex = Math.floor(Math.random() * this.voucherList.length) % this.voucherList.length
      this.voucher = this.voucherList[this.voucherIndex]
      this.hascoupon = true
    },

    buy (data) {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      cartAdd(data.goods_id, 1).then(
        res => {
          Toast(res.message)
          this.ifWait = false
        },
        error => {
          Toast(error.message)
          this.ifWait = false
        }
      )
    },
    hideani () {
      this.hasgift = false
      this.giftAvatar = ''
      this.giftNick = ''
    },
    showgoods () {
      this.animation2 = true
    },
    hidegoods () {
      this.animation2 = false
    },
    showGift () {
      this.animation = true
    },
    sendgift () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      MessageBox.confirm('هل أنت متأكد أنك تريد منح المرساة هدية؟').then(action => {
        addGift(this.liveApplyInfo.live_apply_id).then(res => {
          this.hideGift()
          this.ifWait = false
        }).catch(error => {
          Toast(error.message)
          this.ifWait = false
        })
      }).catch(error => {
      })
    },
    hideGift () {
      this.animation = false
    },
    like () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      addLike(this.liveApplyInfo.live_apply_id).then(res => {
        this.ifWait = false
      }).catch(error => {
        this.ifWait = false
      })
    },
    attention () {
      if (this.ifWait) {
        return
      }
      this.ifWait = true
      if (!this.ifLike) {
        addFavoriteStore(this.liveApplyInfo.live_apply_user_id).then(
          response => {
            Toast(response.message)
            this.ifLike = !this.ifLike
            this.ifWait = false
          },
          error => {
            Toast(error.message)
            this.ifWait = false
          }
        )
      } else {
        delFavoriteStore(this.liveApplyInfo.live_apply_user_id).then(
          response => {
            Toast(response.message)
            this.ifLike = !this.ifLike
            this.ifWait = false
          },
          error => {
            Toast(error.message)
            this.ifWait = false
          }
        )
      }
    },
    quitGroup () {
      MessageBox.confirm('هل أنت متأكد أنك تريد الخروج من البث المباشر؟').then(action => {
        if (this.openLive) {
          this.closeLive = true
        }
        if (this.clientId) {
          leaveLive(this.liveApplyInfo.live_apply_id, this.clientId).then(res => {
            this.$router.go(-1)
          }).catch(error => {
            Toast(error.message)
          })
        } else {
          this.$router.go(-1)
        }
      })
    },
    _getVarsByKey (arr, key) {
      var res
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].key === key) {
          res = arr[i].value
          break
        }
      }
      return res
    },
    toggleChat () {
      this.showChat = !this.showChat
    },
    sendMessage (data) {
      if (!this.ifConnect) {
        Toast('غير متصل بنظام الدردشة')
        return
      }
      if (!data) {
        Toast('الرجاء إدخال محتوى الدردشة')
        return
      }
      addInstantMessage({
        to_id: this.liveApplyInfo.live_apply_id,
        to_type: 2,
        message: data,
        message_type: 0
      }).then(res => {
        Toast(res.message)
      }).catch(error => {
        Toast(error.message)
      })
    },
    goCloseLive () {
      MessageBox.confirm('هل أنت متأكد أنك تريد الخروج من البث المباشر؟', 'تذكير الخروج').then(action => {
        if (this.openLive) {
          this.closeLive = true
        }
        if (this.clientId) {
          leaveLive(this.liveApplyInfo.live_apply_id, this.clientId).then(res => {
            this.$router.go(-1)
          }).catch(error => {
            Toast(error.message)
          })
        } else {
          this.$router.go(-1)
        }
      })
    },
    createWebSocket () {
      try {
        ws = new WebSocket(this.liveApplyInfo.instant_message_url)
        this.init()
      } catch (e) {
        this.reconnect()
      }
    },
    init () {
      ws.onopen = this.wsOpen
      ws.onmessage = this.wsMessage
      ws.onclose = this.wsClose
      ws.onerror = this.wsError
    },
    reconnect () {
      if (this.lockReconnect) {
        return
      };
      this.lockReconnect = true
      // 没连接上会一直重连，设置延迟避免请求过多
      this.timeOut && clearTimeout(this.timeOut)
      var _this = this
      this.timeOut = setTimeout(function () {
        _this.createWebSocket()
        _this.lockReconnect = false
      }, 4000)
    },
    wsOpen () {
      this.ifConnect = true
      // 心跳检测重置
      heartCheck.start()
    },
    wsMessage (res) {
      var message = JSON.parse(res.data)
      if (!message) {
        Toast('فشل تحويل الرسالة:' + res.data)
        return
      }
      var type = message.type || ''
      switch (type) {
        // Events.php中返回的init类型的消息，将client_id发给后台进行uid绑定
        case 'init':
          this.clientId = message.client_id

          joinLive(this.liveApplyInfo.live_apply_id, this.clientId).then(res => {

          }).catch(error => {
            Toast(error.message)
          })
          break
        case 'leave':
          this.groupInfo.memberNum = message.online_count
          break
        case 'join':
          this.groupInfo.memberNum = message.online_count
          break
        case 'gift':
          this.hasgift = true
          this.giftAvatar = message.member.member_avatar
          this.giftNick = message.member.member_name
          setTimeout(() => {
            this.hasgift = false
            this.giftAvatar = ''
            this.giftNick = ''
          }, 1000)
          break
        default:
          let msg = []
          msg.push({
            name: message.instant_message_from_name,
            message: message.instant_message,
            id: message.instant_message_id
          })
          this.message = this.message.concat(msg)
          this.$forceUpdate()
      }
      heartCheck.start()
    },
    wsClose (res) {
      this.ifConnect = false
      if (res.reason) {
        Toast('نظام الدردشة غير متصل:' + res.reason)
      }
      this.reconnect()
    },
    wsError (res) {
      Toast(res.errMsg)
      this.reconnect()
    }
  }
}
// 心跳检测
var heartCheck = {
  timeout: 3000,
  timeoutObj: null,
  start: function () {
    var self = this
    this.timeoutObj && clearTimeout(this.timeoutObj)
    this.timeoutObj = setInterval(function () {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息，
      ws.send('123456789')
    }, this.timeout)
  }
}
</script>
<style lang="scss" scoped>
  #id_test_video{position: fixed;top:0;bottom:0;left:0;right:0;}
  .room-bg {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    position: relative;
  }
  .bg-img {
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }
  .room-content {
    height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .room-bottom {
    position: absolute;
    bottom: 0;
    width: 100vw;
    height: 2.5rem;
    margin-bottom: constant(safe-area-inset-bottom);
    /* 兼容 iOS < 11.2 */
    margin-bottom: env(safe-area-inset-bottom);
    /* 兼容 iOS >= 11.2 */
  }
  .chatroom {
    width: 50vw;
    max-height: 30vh;
    position: absolute;
    bottom: 6rem;
    z-index: 100;
    padding: 0.4640625rem
  }
  .gifts,
  .goodslist {
    position: absolute;
    width: 100vw;
    height: 45vh;
    background-color: #fff;
    bottom: -45vh;
    z-index: 800;
    left: 0;
    transition: bottom 0.2s;
  }
  .gift-animation {
    position: absolute;
    top: 30vh;
    left: 0.421875rem;
  }
  .coupon {
    margin-top: 8.4375rem;
  }
  .live-player {
    width: 100vh;
    height: 100vw;
    background-color: #fff;
  }
  .notice {
    position: absolute;
    left: 0.421875rem;
    bottom: 50vh;
    max-width: 60vw;
  }
</style>
